import type {AxiosError} from 'axios';
import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	confirmRecoveryCode,
	type ConfirmRecoveryCodeErrorResponse,
	type ConfirmRecoveryCodeRequest,
	type ConfirmRecoveryCodeResponse,
} from '../../http';

export function useConfirmRecoveryCode(
	options?: UseMutationOptions<
		ConfirmRecoveryCodeResponse,
		AxiosError<ConfirmRecoveryCodeErrorResponse>,
		ConfirmRecoveryCodeRequest
	>,
): UseMutationResult<
	ConfirmRecoveryCodeResponse,
	AxiosError<ConfirmRecoveryCodeErrorResponse>,
	ConfirmRecoveryCodeRequest
> {
	return useMutation<
		ConfirmRecoveryCodeResponse,
		AxiosError<ConfirmRecoveryCodeErrorResponse>,
		ConfirmRecoveryCodeRequest
	>((request) => confirmRecoveryCode(request).then(({data}) => data), options);
}
